import API from './axiosInstance';

/**
 * /msg-log/export-data is an async job, not an immediate file download: it
 * returns { status: 'processing', status_url, ... } and the actual CSV is
 * only ready once polling status_url returns { status: 'completed',
 * download_url, filename, ... }.
 *
 * The request+poll loop itself lives in CsvExportContext (src/context/), not
 * here — a plain async loop dies with the component/page that started it, so
 * it couldn't survive a reload. This file just keeps the one piece every
 * consumer (the context, and the "download instantly" case where the job is
 * already 'completed' on the first response) shares: fetching the finished
 * file and triggering the actual browser download.
 */

/**
 * Fetches the completed export's CSV and triggers a browser download.
 * `signal` (an AbortController's) lets the caller cancel a large in-flight
 * transfer rather than just hiding the status banner while it keeps running.
 */
export async function downloadCsvFile({ downloadUrl, filename, headers, signal }) {
    const fullUrl = /^https?:\/\//i.test(downloadUrl) ? downloadUrl : `${process.env.REACT_APP_API_URL}${downloadUrl}`;
    const response = await API.get(fullUrl, { headers, responseType: 'blob', signal });
    const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || 'export.csv';
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
}
